/*
 * @Descripttion:
 * @version:
 * @Author: suiyue
 * @email: 1373842098@qq.com
 * @Date: 2022-05-05 17:47:30
 * @LastEditors: K
 * @LastEditTime: 2022-09-01 17:32:52
 */
import { unwrapResult } from '@reduxjs/toolkit'
import { Col } from 'antd'
import form from 'antd/lib/form'
import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useLocation } from 'react-router-dom'
import { RootDispatch } from '../../app/store'
import { TabBar, TabPane } from '../../compnents/widgets/TabBar'
import { getSystemList } from '../tenant/setting/TenentSettingSlice'
import { LimitPrice } from './limitPrice/LimitPrice'
import styles from './Insurance.module.css'
import { PaymentRatio } from './paymentRatio/PaymentRatio'
import { ProvinceCatalog } from './province/Province'
import { CatalogeUpdate } from './catalogUpdate/catalogeUpdate'
import { DiseaseSetPage } from '../diseaseSet/diseaseSetPage'

export const Insurance = () => {
  const location: any = useLocation()

  const dispatch = useDispatch<RootDispatch>()

  useEffect(() => {
    dispatch(getSystemList())
  }, [])

  return (
    <Col className={styles.container}>
      <TabBar
        defaultActiveKey={location.state ? location.state.station : '1'}
      >
        <TabPane key='1' tab='省目录'>
          <ProvinceCatalog />
        </TabPane>
        <TabPane key='2' tab='自付比例'>
          <PaymentRatio />
        </TabPane>
        <TabPane key='3' tab='医保限价'>
          <LimitPrice />
        </TabPane>
        <TabPane key='4' tab='目录更新分析'>
          <CatalogeUpdate />
        </TabPane>
        <TabPane key='5' tab='疾病设置'>
          <DiseaseSetPage />
        </TabPane>
      </TabBar>
    </Col>
  )
}
